export enum RoutesEnum {
  ABOUT_BANK = 'about',
  ACCOUNTS = 'accounts',
  ACQUIRING = 'acquiring',
  ALIENATED_PROPERTY = 'alienated-property',
  ANNOUNCEMENTS = 'announcements',
  ARCHIVE = 'archive',
  ATMS = 'atms',
  BLOG = 'blog',
  BONDS = 'bonds',
  BRAND_RESOURCES = 'brand-resources',
  BRANCHES = 'branches',
  CALCULATORS = 'calculators',
  CAREERS = 'careers',
  CARDS = 'cards',
  CHRONOLOGY = 'chronology',
  CLIENT_RIGHTS = 'client-rights',
  COMPLIANCE = 'compliance',
  CONTACT = 'contact',
  CORPORATE_MANAGEMENT = 'corporate-management',
  DEPOSITS = 'deposits',
  DIGITAL = 'digital',
  EXCHANGE_RATES = 'exchange-rates',
  FINANCING = 'financing',
  HISTORY = 'history',
  HOME = 'home',
  INVEST = 'invest',
  INVEST_CONTENT = 'content',
  INVEST_TO_INVESTORS = 'to-investors',
  INVEST_RESULTS = 'results',
  LOAN = 'loan',
  LOANS = 'loans',
  LOGISTICS_TENDER = 'logistics-tender',
  MANAGEMENT = 'management',
  NEWS = 'news',
  ONLINE_APPLICATIONS = 'online-applications',
  REGULATIONS = 'regulations',
  REPORTS = 'reports',
  RESPONSIBILITIES = 'responsibilities',
  SERVICES = 'services',
  PRACTICE = 'practice',
  MORE = 'more',
  NOT_FOUND = 'not-found',
  SEARCH_RESULTS = 'search-results',
  SPECIAL_OFFER = 'special-offer',
  SPECIAL_OFFERS = 'special-offers',
  SHAREHOLDERS = 'shareholders',
  TARIFFS = 'tariffs',
  TRAINEE = 'trainee',
  TARIFFS_ARCHIVE = 'tariffs-archive',
  TERMS_OF_SERVISES = 'terms-of-services',
  USEFUL_LINKS = 'useful-links',
  SUSTAINABLE_DEVELOPMENT = 'sustainable-development',
  PACKAGES = 'packages',
}
